import { takeLatest } from "redux-saga/effects";

import * as ActionsTypes from "../../../../common/state/StatesConstants";
import { loginUserSaga } from "./AuthSaga";

export default function* CountriesWatcher() {
  yield takeLatest(ActionsTypes.LOGIN_USER, loginUserSaga);
}